import React, { Component } from "react";
import Blades from "./Blades";
import { sectorWiseProjects } from "../../../actions/common.action";
import { Image } from "react-bootstrap";
import IconProjects from "../../../assets/icon-projects.svg";
import CostIcon from "../../../assets/project-value.svg";
import hoverPattern from "../../../assets/hover_pattern.png";
import pattern from "../../../assets/pattern-2.png";
import { formatNumberOnDashBoard } from "../../../helper";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { getPath } from "./sectorWheel.selector";

export class SectorsWheel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      viewAllSector: "",
      viewAllList: [],
      list: [],
      realDegree: 0,
      adjustedDegree: 0,
      defaultDeg: 68,
      duration: 5500,
      currentActive: 0,
      deg: 22.5,
      newDeg: 0,
      paused: false,
      dropdownSelectedSector: null
    };

    this.upButton = React.createRef();
    this.downButton = React.createRef();
  }

  componentDidMount() {
    const { duration } = this.state;
    this.getSectorWiseData();

    // Rotate wheel
    this.rotateWheel = setTimeout(() => {
      const { realDegree, deg } = this.state;
      this.setState({
        currentActive: 15,
        newDeg: deg * 15,
        realDegree: realDegree + deg
      });
    }, duration);
  }

  getSectorWiseData = async () => {
    const { deg, defaultDeg } = this.state;
    let response = await sectorWiseProjects();
    if (response && response.status) {
      this.setState({
        list: response.data.data,
        newDeg: deg * 15,
        realDegree: defaultDeg - deg * 15
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { duration, deg, paused } = this.state;
    if (prevState.currentActive !== this.state.currentActive && !paused) {
      clearTimeout(this.rotateWheel);
      const { realDegree, deg } = this.state;
      //Rotate wheel
      this.rotateWheel = setTimeout(() => {
        // const newActive = (this.state.currentActive < 15 ? this.state.currentActive + 1 : 0);
        const newActive =
          this.state.currentActive === 0 ? 15 : this.state.currentActive - 1;
        this.setState({
          currentActive: newActive,
          newDeg: deg * newActive,
          realDegree: realDegree + deg
        });
      }, duration);
    }
  }

  getExtraDegree = index => {
    let extraAdd = 0;
    switch (index) {
      case 1:
        extraAdd = 10;
        break;
      case 2:
        extraAdd = 5;
        break;
      case 17:
        extraAdd = 5;
        break;
      case 16:
        extraAdd = 6;
        break;
      case 13:
      case 7:
        extraAdd = 2;
        break;
      case 0:
        extraAdd = 10;
        break;
      default:
        extraAdd = 0;
    }
    return extraAdd;
  };

  bladeClicked = selectedIndex => {
    const { deg, currentActive, realDegree } = this.state;
    clearTimeout(this.rotateWheel);

    let diff = 0;
    if (currentActive < 4 && selectedIndex > 11) {
      diff = realDegree + (15 - selectedIndex + 1 + currentActive) * deg;
    } else if (currentActive > 11 && selectedIndex < 4) {
      diff = realDegree - (selectedIndex + 1 + (15 - currentActive)) * deg;
    } else {
      diff =
        selectedIndex - currentActive > 0
          ? realDegree - (selectedIndex - currentActive) * deg
          : realDegree + -(selectedIndex - currentActive) * deg;
    }

    this.setState({
      newDeg: deg * selectedIndex,
      currentActive: selectedIndex,
      realDegree: diff,
      dropdownSelectedSector: null
    });
  };

  onUpBladeClick = () => {
    this.upButton.classList.add("disabled");
    const { deg, currentActive, realDegree } = this.state;
    const newSelected = currentActive < 15 ? currentActive + 1 : 0;
    clearTimeout(this.rotateWheel);
    this.setState({
      newDeg: deg * newSelected,
      currentActive: newSelected,
      realDegree: realDegree - deg,
      dropdownSelectedSector: null
    });
    this.enableButton = setTimeout(() => {
      this.upButton.classList.remove("disabled");
    }, 500);
  };

  onDownBladeClick = () => {
    this.downButton.classList.add("disabled");
    const { deg, currentActive, realDegree } = this.state;
    const newSelected = currentActive != 0 ? currentActive - 1 : 15;
    clearTimeout(this.rotateWheel);
    this.setState({
      newDeg: deg * newSelected,
      currentActive: newSelected,
      realDegree: realDegree + deg,
      dropdownSelectedSector: null
    });
    this.enableButton = setTimeout(() => {
      this.downButton.classList.remove("disabled");
    }, 500);
  };

  pauseWheelRotation = () => {
    clearTimeout(this.rotateWheel);
    this.setState({
      paused: true
    });
  };

  resumeWheelRotation = () => {
    const { duration, deg, realDegree } = this.state;
    this.rotateWheel = setTimeout(() => {
      const newActive =
        this.state.currentActive == 0 ? 15 : this.state.currentActive - 1;
      this.setState({
        currentActive: newActive,
        newDeg: deg * newActive,
        realDegree: realDegree + deg,
        paused: false,
        dropdownSelectedSector: null
      });
    }, duration);
  };

  onDropdownClick = sector => {
    this.pauseWheelRotation();
    this.setState({
      dropdownSelectedSector: sector
    });
  };

  /* getPathForImage = sectorName => {
    const _sectorName = sectorName && sectorName.toLowerCase().replace(/\s+/g,'')
        .replace('&', '')
        .replace('/', '');

    console.log(_sectorName, "sectorname");
    return _sectorName;
  };*/

  render() {
    const {
      list,
      currentActive,
      deg,
      realDegree,
      dropdownSelectedSector
    } = this.state;
    // const newWheelDeg = (defaultDeg - newDeg > 0 ? defaultDeg - newDeg : defaultDeg + (deg * (list.length - currentActive)));
    const extraRotation = this.getExtraDegree(currentActive);
    const showLimited = list && list.slice(0, 16);
    const dropdownSectors = list && list.slice(16, list && list.length);
    const svgStyle = {
      transform: `rotate(${realDegree + extraRotation - 20}deg)`,
      transition: `transform 0.5s ease-out 0.3s`
    };

    const sectorData = dropdownSelectedSector
      ? dropdownSelectedSector
      : showLimited && showLimited.length
      ? showLimited[currentActive]
      : {};

    //const pathForImage = sectorData && this.getPathForImage(sectorData.sectorName);
    const pathForImage = sectorData && getPath(sectorData.sectorName);

    return (
      <>
        {list && list.length ? (
          <div className="wheel-wrapper">
            <div
              id="sectors"
              className="sectors-info sector-state-txt"
              onMouseOver={() => this.pauseWheelRotation()}
              onMouseLeave={() => this.resumeWheelRotation()}
            >
              {sectorData && (
                <>
                  <div className="sector-wise-content-inner">
                    <h3>{sectorData.sectorName}</h3>
                    <div className="sector-content">
                      <div className="sector-image">
                        <div className={"image-parent"}>
                          <div className={"image"}>
                            <Image src={pathForImage} alt="photo" />
                          </div>
                        </div>
                      </div>
                      <div className="stats-wrapper">
                        <div className="project-stats">
                          <div className="stats-img">
                            <Image src={IconProjects} alt="Projects" />
                          </div>
                          <div className="sector-stats">
                            <b>{sectorData.projectCount}</b> Project(s)
                          </div>
                        </div>
                        <div className="issue-stats">
                          <div className="stats-img">
                            <Image src={CostIcon} alt="Cost" />
                          </div>
                          <div className="sector-stats">
                            <b>
                              {formatNumberOnDashBoard(
                                Number(sectorData.projectCost.toFixed(1)),
                                true,
                                true,
                                "."
                              )}
                            </b>{" "}
                            Project(s) Investment
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {currentActive !== null && (
              <div className="wheel-container">
                <svg
                  id="wheel"
                  xmlns="http://www.w3.org/2000/svg"
                  width="600"
                  height="600"
                  style={svgStyle}
                  onMouseOver={() => this.pauseWheelRotation()}
                  onMouseLeave={() => this.resumeWheelRotation()}
                >
                  <defs>
                    <pattern
                      id="img"
                      patternUnits="userSpaceOnUse"
                      width="500"
                      height="500"
                    >
                      <image
                        xlinkHref={pattern}
                        x="0"
                        y="0"
                        width="500"
                        height="500"
                      />
                    </pattern>
                  </defs>
                  <defs>
                    <pattern
                      id="hoverImg"
                      patternUnits="userSpaceOnUse"
                      width="500"
                      height="500"
                    >
                      <image
                        xlinkHref={hoverPattern}
                        x="0"
                        y="0"
                        width="500"
                        height="500"
                      />
                    </pattern>
                  </defs>
                  <defs>
                    <filter id="a">
                      <feOffset dy="6" in="SourceAlpha" />
                      <feGaussianBlur result="blurOut" stdDeviation="3" />
                      <feFlood floodColor="#FFF" result="floodOut" />
                      <feComposite
                        in="floodOut"
                        in2="blurOut"
                        operator="out"
                        result="compOut"
                      />
                      <feComposite
                        in="compOut"
                        in2="SourceAlpha"
                        operator="in"
                      />
                      <feComponentTransfer>
                        <feFuncA slope=".47" type="linear" />
                      </feComponentTransfer>
                      <feBlend in2="SourceGraphic" />
                    </filter>

                    <filter id="b">
                      <feOffset dy="6" in="SourceAlpha" />
                      <feGaussianBlur result="blurOut" stdDeviation="3" />
                      <feFlood floodColor="#FFF" result="floodOut" />
                      <feComposite
                        in="floodOut"
                        in2="blurOut"
                        operator="out"
                        result="compOut"
                      />
                      <feComposite
                        in="compOut"
                        in2="SourceAlpha"
                        operator="in"
                      />
                      <feComponentTransfer>
                        <feFuncA slope=".47" type="linear" />
                      </feComponentTransfer>
                      <feBlend in2="SourceGraphic" />
                    </filter>
                  </defs>
                  <g id="shapes">
                    {showLimited && (
                      <Blades
                        blades={showLimited}
                        degree={deg}
                        currentActive={currentActive}
                        isDropdownSelected={dropdownSelectedSector !== null}
                        selectBlade={selectedIndex =>
                          this.bladeClicked(selectedIndex)
                        }
                      />
                    )}
                  </g>
                </svg>
                <div className="outer-circle">
                  <div className="inner-circle">
                    <div className="rotation-arrows">
                      <span
                        className="upBtn"
                        onMouseOver={() => this.pauseWheelRotation()}
                        onMouseLeave={() => this.resumeWheelRotation()}
                        onClick={() => this.onUpBladeClick()}
                        ref={ref => (this.upButton = ref)}
                      >
                        &nbsp;
                      </span>
                      <span
                        className="downBtn"
                        onMouseOver={() => this.pauseWheelRotation()}
                        onMouseLeave={() => this.resumeWheelRotation()}
                        onClick={() => this.onDownBladeClick()}
                        ref={ref => (this.downButton = ref)}
                      >
                        &nbsp;
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="sector-dropdown-wrapper">
              <div className="sector-dropdown">
                <div className="view-lists-button inner-button">
                  View Other Sectors
                </div>
                <div className="view-lists">
                  <PerfectScrollbar className="field-mscb-scroll">
                    <ul>
                      {dropdownSectors &&
                        dropdownSectors.map((sector, i) => {
                          return (
                            <li key={i}>
                              <a onClick={() => this.onDropdownClick(sector)}>
                                {sector.sectorName}
                              </a>
                            </li>
                          );
                        })}
                    </ul>
                  </PerfectScrollbar>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default SectorsWheel;
